import TaskService from '../services/task.service'
import TimeLogService from '../services/time-log.service'
import { stripTaskTimeTrackingFields, TASK_SPENT_TIME_FIELDS, updateTaskChangedFields } from '../page/Project/utils/taskPayload'

interface PersistRelatedTaskOptions {
    task: any
    parentTaskId: number | string
    projectId: number | string
    syncTime?: boolean
    changes?: Record<string, any>
}

function getFirstDefinedField(task: any, fields: string[]) {
    const field = fields.find((currentField) => task?.[currentField] !== undefined)
    return field ? task[field] : undefined
}

export async function persistRelatedTask({ task, parentTaskId, projectId, syncTime = false, changes }: PersistRelatedTaskOptions) {
    const taskPayload = stripTaskTimeTrackingFields({
        ...task,
        parent_id: parentTaskId,
        project_id: task?.project_id ?? projectId,
    })
    const persistedTask = task?.id
        ? changes
            ? Object.keys(changes).length
                ? await updateTaskChangedFields(task.id, Number(projectId), changes)
                : task
            : await TaskService.update(task.id, taskPayload)
        : await TaskService.create(taskPayload)
    const persistedTaskId = persistedTask?.id ?? task?.id

    if (persistedTaskId == null) {
        throw new Error('Persisted related task has no id')
    }

    // Existing stages already persist time directly from TimeTrackerPicker.
    // Merely closing their parent must never rewrite a loaded time value.
    if (!task?.id || syncTime) {
        await TimeLogService.syncForTask({
            taskId: persistedTaskId,
            spendTime: getFirstDefinedField(task, TASK_SPENT_TIME_FIELDS),
            description: task?.timeLogDescription ?? task?.time_log_description ?? '',
            timeLogId: task?.timeLogId ?? task?.time_log_id,
        })
    }

    return persistedTask
}
